
    document.addEventListener("DOMContentLoaded", (event) => {
        var carouselSections = document.querySelectorAll(".HPcarousel-section")
        carouselSections.forEach((section) => {
            const currentSection = this;
            const HPcarousel = section.querySelector(".HPcarousel");
            const wrapper = section.querySelector(".HPcarousel-container");
            const leftArrow = section.querySelector(".left-arrow");
            const rightArrow = section.querySelector(".right-arrow");
            let currentIndex = 0;
            let prevIndex;
            const images = section.querySelectorAll(".HPcarousel-image");
            var currentImageOrder;
            const totalImages = Object.keys(images).length;
            var slideIndex = 0;
            var beingSwiped = false;
            var timeoutId;
            const carouselControls = section.querySelector(".HPcarousel-controls-container")
            // sets width of each item to fit 4
          if(window.innerWidth > 768){
            HPcarousel.style.width = `calc(25% * ${totalImages})`
           
          }else{
            HPcarousel.style.width = `calc(55% * ${totalImages})`
          }
            var imageWidth = (images[1].clientWidth + 20)

            //reassigns image width if the screen is resized
            window.addEventListener("resize", function () {
                imageWidth = (images[1].clientWidth + 20)

            }, true);


            if (images.length > 4) {
                leftArrow.addEventListener("click", () => {
                    if (!beingSwiped) {
                        beingSwiped = true;
                        prevIndex = currentIndex;
                        currentIndex = (currentIndex - 1 + totalImages) % totalImages;
                        HPcarousel.style.transform = `translateX(-${imageWidth}px)`;
                        HPcarousel.insertBefore(images[currentIndex], HPcarousel.firstChild);
                        currentImageOrder = section.querySelectorAll(".HPcarousel-image")
                        currentImageOrder[0].style.transform = "translateX(-150px)"

                        if (slideIndex == 0) {
                            slideIndex = (totalImages - 1);
                            highlightNotches(slideIndex);

                        }
                        else {
                            slideIndex--;
                            highlightNotches(slideIndex);

                        }

                        if (!carouselPaused) {
                            clearInterval(timeoutId);
                        }

                        leftArrow.disabled = true;
                        setTimeout(() => {
                            HPcarousel.style.transform = "";
                            currentImageOrder[0].style.transform = ""
                            HPcarousel.classList.add("sliding-transition");
                        }, 10);

                        setTimeout(() => {
                            leftArrow.disabled = false;
                            beingSwiped = false;
                            HPcarousel.classList.remove("sliding-transition");
                            if (!carouselPaused) {
                                autoPlay();
                            }
                        }, 740);
                    }
                });



                rightArrow.addEventListener("click", () => {
                    if (!beingSwiped) {
                        beingSwiped = true;
                        currentImageOrder = section.querySelectorAll(".HPcarousel-image")
                        HPcarousel.classList.add("sliding-transition");
                        rightArrow.disabled = true;
                        prevIndex = currentIndex;
                        currentIndex = (currentIndex + 1) % totalImages;
                        HPcarousel.style.transform = `translateX(-${imageWidth}px)`;

                        if (currentImageOrder.length > 5) {
                            currentImageOrder[5].style.transform = "translateX(100px)"
                        }

                        if (currentImageOrder.length > 4) {
                            currentImageOrder[4].style.transform = "translateX(0px)"
                            currentImageOrder[0].style.transform = "translateX(-100px)"
                        }


                        if (slideIndex == (totalImages - 1)) {
                            slideIndex = 0;
                            highlightNotches(slideIndex);
                        }
                        else {
                            slideIndex++;
                            highlightNotches(slideIndex);

                        }

                        if (!carouselPaused) {
                            clearInterval(timeoutId);
                        }

                        setTimeout(() => {
                            HPcarousel.appendChild(images[prevIndex]);
                            HPcarousel.classList.remove("sliding-transition");
                            HPcarousel.style.transform = "";

                            if (currentImageOrder.length > 5) {
                                currentImageOrder[5].style.transform = ""
                            }
                            if (currentImageOrder.length > 4) {
                                currentImageOrder[4].style.transform = ""
                                currentImageOrder[0].style.transform = ""
                            }
                            if (!carouselPaused) {
                                autoPlay();
                            }

                            beingSwiped = false;
                            rightArrow.disabled = false;
                        }, 750);
                    }
                });

                var sliderNotch = `<span class="slider-notch"></span>`;
                var notchContainer = section.querySelector(".slider-controls-container");
                const buildNotches = () => {
                    for (let i = 1; i < totalImages; i++) {
                        notchContainer.innerHTML += sliderNotch
                    }
                }
                buildNotches();
                const notches = [...notchContainer.children];

                function highlightNotches(index) {
                    notches.forEach(element => {
                        element.classList.remove("active-slider-notch")
                    });
                    notches[index].classList.add("active-slider-notch")
                }





                var isAutoPlay = true;
                const autoPlay = () => {
                    if (!isAutoPlay) return; // Return if window is smaller than 800 or isAutoPlay is false
                    // Autoplay the carousel after every 2500 ms
                    timeoutId = setInterval(() => {
                        currentImageOrder = section.querySelectorAll(".HPcarousel-image")
                        HPcarousel.classList.add("sliding-transition");
                        rightArrow.disabled = true;
                        prevIndex = currentIndex;
                        currentIndex = (currentIndex + 1) % totalImages;
                        HPcarousel.style.transform = `translateX(-${imageWidth}px)`;


                        if (currentImageOrder.length > 5) {
                            currentImageOrder[5].style.transform = "translateX(100px)"
                        }
                        if (currentImageOrder.length > 4) {
                            currentImageOrder[4].style.transform = "translateX(0px)"
                            currentImageOrder[0].style.transform = "translateX(-100px)"
                        }

                        if (slideIndex == (totalImages - 1)) {
                            slideIndex = 0;
                            highlightNotches(slideIndex);
                        }
                        else {
                            slideIndex++;
                            highlightNotches(slideIndex);

                        }

                        setTimeout(() => {
                            HPcarousel.appendChild(images[prevIndex]);
                            HPcarousel.classList.remove("sliding-transition");
                            HPcarousel.style.transform = "";

                            if (currentImageOrder.length > 5) {
                                currentImageOrder[5].style.transform = ""
                            }
                            currentImageOrder[0].style.transform = ""
                            if (currentImageOrder.length > 4) {
                                currentImageOrder[4].style.transform = ""
                                currentImageOrder[0].style.transform = ""
                            }
                            rightArrow.disabled = false;
                        }, 750);
                    }, 2500);
                }
                autoPlay();

                var carouselplayPauseBtn = section.querySelector("#hp-carousel-playPauseBtn");
                var carouselplayBtn = section.querySelector("#hp-carousel-svg-icon-video-play");
                var carouselpauseBtn = section.querySelector("#hp-carousel-svg-icon-video-pause");
                var carouselPaused = false;
                var carouselInViewport = true;
                var manuallyPaused = false;

                carouselplayPauseBtn.onclick = function () {
                    carouselplayPauseHandler();
                }
                function carouselplayPauseHandler() {
                    if (carouselpauseBtn.classList.contains("hp-carousel-playPauseShowing")) {
                        carouselPaused = true;
                        manuallyPaused = true;
                        clearInterval(timeoutId)
                        carouselpauseBtn.classList.replace("hp-carousel-playPauseShowing", "hp-carousel-playPauseHidden");
                        carouselplayBtn.classList.replace("hp-carousel-playPauseHidden", "hp-carousel-playPauseShowing");
                    } else {
                        carouselPaused = false;
                        autoPlay();
                        carouselpauseBtn.classList.replace("hp-carousel-playPauseHidden", "hp-carousel-playPauseShowing");
                        carouselplayBtn.classList.replace("hp-carousel-playPauseShowing", "hp-carousel-playPauseHidden");
                    }
                }

                var carouselInViewport = true;
                var hpcarouselWindow = new IntersectionObserver(function (entries) {
                    if (entries[0]['isIntersecting'] === true) {
                        //carousel in view
                        if (!carouselPaused) {
                            return;
                        }
                        else {
                            clearInterval(timeoutId)
                            carouselplayPauseHandler();
                        }
                    }
                    else {
                        //carousel not in view
                        if (carouselPaused) {
                            return;
                        }
                        else {
                            clearInterval(timeoutId)
                            carouselplayPauseHandler();
                            carouselInViewport = false;
                        }
                    }
                }, { threshold: [0.8] });
                hpcarouselWindow.observe(wrapper);
            }
            if (images.length <= 4) {
                carouselControls.style.display = "none";
            }

        })
    });
